<template>
  <section class="table-sampler-classification-noise">
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>VDVR</label>
        <select type="text" class="form-control" v-model="model.vdvr" required>
          <option value="0 a 9,1">0 a 9,1</option>
          <option value="9,1 a 16,4">9,1 a 16,4</option>
          <option value="16,4 a 21">16,4 a 21</option>
          <option value="Acima de 21">Acima de 21</option>
        </select>
      </d-col>
      <d-col cols="auto">
        <label>Aren</label>
        <select type="text" class="form-control" v-model="model.aren" required>
          <option v-for="option in arenOptions" :key="option.value" :value="option.label">{{ option.label }}</option>
        </select>
      </d-col>
      <d-col cols="auto">
        <label>Considerações</label>
        <select type="text" class="form-control" v-model="model.consideration" required>
          <option value="Aceitável">Aceitável</option>
          <option value="Acima do nível de ação">Acima do nível de ação</option>
          <option value="Região de incerteza">Região de incerteza</option>
          <option value="Acima do limite de exposição">Acima do limite de exposição</option>
        </select>
      </d-col>
      <d-col cols>
        <label>Recomendação</label>
        <select type="text" class="form-control" v-model="model.recomendation" required>
          <option value="Manutenção da condição existente">Manutenção da condição existente</option>
          <option value="Adoção de medidas preventivas">Adoção de medidas preventivas</option>
          <option value="Adoção de medidas preventivas e corretivas para redução da exposição">Adoção de medidas preventivas e corretivas para redução da exposição</option>
          <option value="Adoção imediata de medidas corretivas">Adoção imediata de medidas corretivas</option>
        </select>
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="12">
        <label>Recomendação da exposição</label>
        <textarea
          type="text"
          class="form-control"
          v-model="model.exposition_recomendation"
          required
        ></textarea>
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { NOISE_CLASSIFICATION, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Classification-Vibration',
  props: {
    classification: {
      type: Object,
      default: null,
    },
  },
  computed: {
    arenOptions() {
      const { memory_field: memoryField } = this.$store.state.sample.sample;
      if (memoryField && memoryField.vibration_type === 'corpo') {
        return [
          { value: '0a0,5', label: '<0 a 0,5' },
          { value: '0,5a0,9', label: '0,5 e <0,9' },
          { value: '0,9a1,1', label: '0,9 a 1,1' },
          { value: 'acima', label: 'acima de 1,1' },
        ];
      }
      return [
        { value: '0a2,5', label: '<0 a 2,5' },
        { value: '2,5a3,5', label: '2,5 e <3,5' },
        { value: '3,5a5', label: '3,5 a 5' },
        { value: 'acima', label: 'acima de 5' },
      ];
    },
  },
  data() {
    return {
      model: cloneDeep(NOISE_CLASSIFICATION),
    };
  },
  methods: {
    setModel() {
      if (this.classification) {
        this.model = this.classification;
      }
    },
  },
  mounted() {
    this.setModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:classification', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
